import styled from "styled-components";

import { Palette } from "../../vars";

const OverlayToolbar = styled.div`
  background: ${Palette.OVERLAY_TOOLBAR_BG};
  border-bottom: 1px solid ${Palette.Rebrand.Colours.G2};
  position: fixed;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 101;
`;

export default OverlayToolbar;
